import { FC } from 'react'

import { TeamPerson } from 'api/strapi/teams/types'
import { Heading } from 'components/heading'
import { Link, LinkButton } from 'components/links'
import { cn } from 'utils'
import { LinkedinLink } from 'components/linkedin-link'
import { TeamMemberAvatar } from 'components/team-members/team-member-avatar'
import { normalizePersonPosition } from 'components/team-members/utils'
import { routes } from 'utils/routes'

import classes from './team-member-item.module.css'

export interface TeamMemberItemProps {
  item: TeamPerson
  className?: string
  linkTarget?: '__blank'
}
export const TeamMemberItem: FC<TeamMemberItemProps> = ({ item, className, linkTarget }) => {
  const href = routes.teamMember(item.id)

  return (
    <li className={cn(classes.listItem, className)}>
      <Link href={href} className={classes.photoLink} target={linkTarget}>
        <TeamMemberAvatar person={item} width={130} height={130} />
      </Link>
      <div className={classes.listItemContent}>
        <Heading theme="h5" component="h3" className={classes.fullName}>
          <Link href={href} className={classes.fullNameLink}>
            {item.full_name}
          </Link>

          {item.linkedin && (
            <LinkedinLink href={item.linkedin} name={item.full_name} className={classes.linkedin} />
          )}
        </Heading>
        <ul className={classes.positions}>
          {normalizePersonPosition(item.position).map((position) => (
            <li key={position} className={classes.position}>
              {position}
            </li>
          ))}
        </ul>
        <LinkButton
          href={href}
          target={linkTarget}
          theme="inlineLink"
          className={classes.detailsLink}
        >
          View bio
        </LinkButton>
      </div>
    </li>
  )
}
